// extracted by mini-css-extract-plugin
module.exports = {"container":"_87cfd68","header":"_63ff7a3","gameList":"_b9410d8"};